import React from "react";
import { Box, Grid } from "@tiny/components";
import SuppressionListTable from "../../components/SuppressionList/SuppressionList";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import SuppressionStats from "./SuppressionStats";

function SuppressionList() {
  const { mdUp, lgUp } = useBreakpoints();

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
      <Grid item xs={12}>
        <SuppressionStats />
      </Grid>
      <Grid item xs={12}>
        <Box
          bgcolor="white"
          p={{ xs: 5, md: 6 }}
          borderRadius={mdUp ? "8px" : "0px"}
        >
          <SuppressionListTable
            segmentTypes={["INTEGRATION", "UPLOAD"]}
            enableBulkDelete
            seeAllSubcribersOnUpload
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default SuppressionList;
